import { useTranslations } from "@jugl-web/utils";
import { EmptyListContent } from "@jugl-web/ui-components/cross-platform/content/EmptyListContent";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { ReactComponent as PlusIcon } from "./assets/plus.svg";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";
import invoicesEmptyListAnimation from "./assets/invoicesEmptyListAnimation.json";
import { useInvoicesTableContext } from "../../context/useInvoicesTableContext";

export const InvoicesInitialList = () => {
  const { t } = useTranslations();
  const { taskId, onNavigate, isGuest } = useInvoicesTableContext();

  const { config } = useInvoicesTableContext();

  const handleClick = () => {
    if (!onNavigate) return;

    if (config?.id) {
      onNavigate("invoicesItemForm", {
        type: "invoice",
      });
    } else {
      onNavigate("invoicesSettingsBusinessInformation");
    }
  };

  if (taskId || isGuest) {
    return <EmptyListContent type="noResults" />;
  }

  return (
    <EmptyListContent
      customImg={
        <Lottie
          options={{
            animationData: invoicesEmptyListAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          width={300}
          height={300}
        />
      }
      type="noResults"
      customTitle={t({
        id: "invoices-empty-list.title",
        defaultMessage: "Stay on top of your payments with zero stress 💸",
      })}
      customSubtitle={t({
        id: "invoices-empty-list.text",
        defaultMessage:
          "Track what's due, what's paid, and what needs your attention - all in one view",
      })}
      customButton={{
        text: config?.id
          ? t({
              id: "invoices-empty-list.create-invoice",
              defaultMessage: "Create invoice",
            })
          : t({
              id: "invoices-empty-list.configure-invoices",
              defaultMessage: "Configure Invoices",
            }),
        onClick: handleClick,
        iconEnd: config?.id ? <PlusIcon /> : <ArrowIcon />,
        color: "primary",
      }}
    />
  );
};
